/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export type CioExportButtonArgs = {
  buttonText: string;
  buttonClass: string;
  disabled: boolean;
  onExport: () => unknown;
  onCancel: () => unknown;
};

export default class CioExportButton extends Component<CioExportButtonArgs> {
  exportPendingImage = new URL('cio/assets/images/export-pending.svg', import.meta.url).toString();
  exportSuccessImage = new URL('cio/assets/images/export-success.svg', import.meta.url).toString();
  exportFailureImage = new URL('cio/assets/images/export-failure.svg', import.meta.url).toString();

  get buttonClass() {
    return this.args.buttonClass ?? 'fly-btn';
  }
}
